// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"84062d26","88":"5fb1851c","143":"e7899be8","217":"bf35ac17","238":"09a6cb92","355":"55e06c96","427":"64142266","462":"ef765c2c","527":"cd1711a0","583":"06334b72","652":"cf45054d","721":"ed643693","751":"c51924ce","781":"d8f2df8f","882":"3544293d","944":"c397a1d3"}[chunkId] + ".chunk.js";
};